'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'car-burst';
var width = 640;
var height = 512;
var aliases = ["car-crash"];
var unicode = 'f5e1';
var svgPathData = 'M161.5 20.5c5.7-12.4 23.4-12.4 29.1 0l31.4 68.2 58.9-14.6L269.1 93.5l-49.8 12.3c-3.7 .9-7.6-.9-9.2-4.4L176 27.2l-34.1 74.2c-1.6 3.5-5.5 5.3-9.2 4.4L53.4 86.2l36.8 73c1.7 3.3 .9 7.3-1.9 9.7L29.7 218.9l73.5 16.8c3.7 .8 6.3 4.2 6.2 7.9l-1.5 81.7L142.1 297 135 323.7l-16.8 13.9c-10.5 8.7-26.4 1.1-26.2-12.6l1.4-75.2L26.1 234.5c-12.8-2.9-16.8-19.2-6.8-27.8l53.7-46L39.1 93.4c-6.2-12.2 4.9-26 18.1-22.7l72.9 18 31.4-68.2zm146.8 70c16.5-27.6 49.3-40.8 80.4-32.5l154 41.3c31.1 8.3 52.8 36.2 53.4 68.4l1.7 100.9c23 23.5 33.4 58.1 24.3 92.2l-18.6 69.5-4.1 15.5L591 476.5c-4.6 17.1-22.1 27.2-39.2 22.6l-30.9-8.3c-17.1-4.6-27.2-22.1-22.6-39.2l8.3-30.9L259.2 354.5 251 385.4c-4.6 17.1-22.1 27.2-39.2 22.6l-30.9-8.3c-17.1-4.6-27.2-22.1-22.6-39.2l8.3-30.9 4.1-15.5 18.6-69.5c9.1-34.1 35.5-58.9 67.1-67.7l51.9-86.5zm271.8 77.4c-.4-25-17.4-46.7-41.5-53.2l-154-41.3c-24.2-6.5-49.7 3.9-62.5 25.3l-44.9 75c9.8-.5 19.8 .5 29.8 3.2L554.1 243c10 2.7 19.1 6.8 27.4 12.1l-1.4-87.4zM587.9 426l18.6-69.5c11.4-42.7-13.9-86.5-56.6-98L302.7 192.2c-42.7-11.4-86.5 13.9-98 56.6l-18.6 69.5 61.8 16.6 15.5 4.1 247.3 66.3 15.5 4.1L587.9 426zm-66-1.1l-8.3 30.9c-2.3 8.5 2.8 17.3 11.3 19.6l30.9 8.3c8.5 2.3 17.3-2.8 19.6-11.3l8.3-30.9L522 424.9zM243.8 350.4L182 333.8l-8.3 30.9c-2.3 8.5 2.8 17.3 11.3 19.6l30.9 8.3c8.5 2.3 17.3-2.8 19.6-11.3l8.3-30.9zm48-86.5a16 16 0 1 0 -30.9-8.3 16 16 0 1 0 30.9 8.3zm-46.4-12.4A32 32 0 1 1 307.3 268a32 32 0 1 1 -61.8-16.6zm289.5 94.1a16 16 0 1 0 8.3-30.9 16 16 0 1 0 -8.3 30.9zm12.4-46.4A32 32 0 1 1 530.8 361a32 32 0 1 1 16.6-61.8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCarBurst = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;